import { JsonPipe } from '@angular/common';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { TostesStore } from '../store/tostes-store';
import { TostPositionEnum, TostTypeEnum } from '../shared/models/tostes.model';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environment';
import { STORAGE_KEYS } from '../shared/storage-keys';
import { AuthStore } from '../store/auth-store';

@Injectable()
export class NetworkAndServerErrorInterceptor implements HttpInterceptor {

  #authService = inject(MsalService);
  #router = inject(Router);
  #tostsStore = inject(TostesStore);
  #authStore = inject(AuthStore);

  constructor(
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (environment.auth == "azure") {
      const authSqValue = localStorage.getItem(STORAGE_KEYS.authHeader);

      if (authSqValue) {
        req = req.clone({
          setHeaders: {
            'Auth-Sq': authSqValue
          }
        });
      }
    }
    if (environment.auth == "idp" || environment.auth == "jwt") {
      if (!req.url.includes('refreshToken')) {
        localStorage.setItem(STORAGE_KEYS.lastRequest, new Date().toString());
      }


      const idToken = localStorage.getItem(STORAGE_KEYS.userToken);
      if (idToken) {
        req = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + idToken),
        });
      }
    }
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.headers.has(STORAGE_KEYS.authHeader)) {
            const myHeaderValue = event.headers.get(STORAGE_KEYS.authHeader);
            localStorage.setItem(STORAGE_KEYS.authHeader, myHeaderValue!);
          }
        }
      }),
      catchError((err: any) => {
        if (
          err instanceof HttpErrorResponse &&
          err.status == 403 ||
          err.status == 401
        ) {
          if (err.status == 401) {
            if (environment.auth == "idp" || environment.auth == "jwt") {
              localStorage.removeItem(STORAGE_KEYS.userToken);
              this.#authStore.navigateToLogin();
            }
          }
          if (err.status == 403) {
            if (environment.auth == "idp" || environment.auth == "jwt") {
              localStorage.removeItem(STORAGE_KEYS.userToken);
            }
            this.#tostsStore.removeAllTost(null);
            // this.#tostsStore.addTost({ guid: this.#tostsStore.generateGuid(), message: { en: "Sorry, There is a problem with your permission", he: "מצטערים ,יש בעיה עם ההרשאה שלך" }, position: TostPositionEnum.BottomLeft, type: TostTypeEnum.ERROR, zIndex: 5 })
            // console.error(` There is a problem with your permission`);
            window.location.href = `${environment.envUrl}/404`;
          }

        }
        if (
          err instanceof HttpErrorResponse &&
          err.status == 409
        ) {
          // console.error(`someOne else enter with your account , i cant let tow users with one account, ${err} `);
          const authSqValue = localStorage.removeItem(STORAGE_KEYS.authHeader);
          if (environment.auth == "azure") {
            this.#authService.instance.logout();
          }
          else {
            this.#authStore.logOut();
          }
          return of();
        }
        if (
          err instanceof HttpErrorResponse &&
          err.status == 500
        ) {
          // Log only the request URL and status, not the full HttpErrorResponse - its body can
          // contain server-side error details (see the backend's own generic-error handling)
          // that shouldn't end up in the browser console / any console-capturing tooling.
          console.error(`Fatal communication or server error for ${err.url} (status ${err.status})`);
          return of();
        }
        // // return of();
        return throwError(() => { return err });
      })
    );
  }

}
